import { DataGrid, TooltipV2 } from '@cimplico/components';
import { CheckIcon } from '@heroicons/react/24/outline';

import { FYIUser } from '../../../types/fyi-docs';

type FYIUserRowProps = {
    id: string;
    user: FYIUser;
    isSelected: boolean;
    isDisabled: boolean;
};
function FYIUserRow({ id, user, isSelected, isDisabled }: FYIUserRowProps): JSX.Element {
    return (
        <DataGrid.Row id={id} selected={isSelected} disabled={isDisabled}>
            <p className="text-gray-700 text-sm py-1 text-left">{user.name}</p>
            <p className="text-gray-700 text-sm py-1 text-left">{user.email}</p>
            <div>
                {user.existingMapping && (
                    <TooltipV2 message="This user has already been invited." position="left">
                        <CheckIcon className="text-indigo-600 h-4 w-4" />
                    </TooltipV2>
                )}
            </div>
        </DataGrid.Row>
    );
}
export default FYIUserRow;
